import { useEffect, useMemo, useState } from "react";
import programsService from "../api/services/programs.service";
import areasService from "../api/services/areas.service";
import { buildClassGroups } from "../utils/classGroups";

const asList = (data) => (Array.isArray(data) ? data : data?.items || []);

/**
 * Combined attendance sheets for a coach's classes (see utils/classGroups).
 * Grouping needs program and area names, which a class does not carry. If
 * that lookup fails the coach simply gets the plain class list, as before.
 */
const useClassGroups = (classes) => {
  const [lookups, setLookups] = useState({ programs: [], areas: [] });
  const worthGrouping = (classes?.length || 0) > 1;

  useEffect(() => {
    if (!worthGrouping) return undefined;
    let cancelled = false;
    Promise.all([programsService.getAll(), areasService.getAll()])
      .then(([programs, areas]) => {
        if (!cancelled) {
          setLookups({ programs: asList(programs), areas: asList(areas) });
        }
      })
      .catch((err) => console.error("Could not load combined sheets:", err));
    return () => {
      cancelled = true;
    };
  }, [worthGrouping]);

  return useMemo(
    () => buildClassGroups(classes || [], lookups.programs, lookups.areas),
    [classes, lookups],
  );
};

export default useClassGroups;
